'use client';

import React, { createContext, useEffect, useState } from 'react';

export const UserEngagementContext = createContext();

export function UserEngagementProvider({ children }) {
  const [hasTidioInteracted, setHasTidioInteractedState] = useState(false);
  const [latestLeadTimestamp, setLatestLeadTimestampState] = useState(null);

  const setHasTidioInteracted = (value) => {
    setHasTidioInteractedState(value);
    localStorage.setItem('hasTidioInteracted', value);
  };

  const setLatestLeadTimestamp = (timestamp) => {
    setLatestLeadTimestampState(timestamp);
    localStorage.setItem('latestLeadTimestamp', timestamp);
  };

  // Feed initial state from localStorage
  useEffect(() => {

    const storedTidioInteraction = localStorage.getItem('hasTidioInteracted');
    const storedLatestLeadTimestamp = localStorage.getItem('latestLeadTimestamp');

    if (storedTidioInteraction === 'true') {
      setHasTidioInteracted(true);
    }
    
    if (storedLatestLeadTimestamp) {
      setLatestLeadTimestamp(storedLatestLeadTimestamp);
    }

  }, []);

  return (
    <UserEngagementContext.Provider
      value={{ hasTidioInteracted, setHasTidioInteracted, latestLeadTimestamp, setLatestLeadTimestamp }}
    >
      {children}
    </UserEngagementContext.Provider>
  );
}
